import _regeneratorRuntime from "C:/Users/lek-bit/Documents/jobs/2020/pannana_ml/app/pannana_ml_admin_frontend/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/Users/lek-bit/Documents/jobs/2020/pannana_ml/app/pannana_ml_admin_frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:/Users/lek-bit/Documents/jobs/2020/pannana_ml/app/pannana_ml_admin_frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "C:/Users/lek-bit/Documents/jobs/2020/pannana_ml/app/pannana_ml_admin_frontend/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "C:/Users/lek-bit/Documents/jobs/2020/pannana_ml/app/pannana_ml_admin_frontend/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "C:/Users/lek-bit/Documents/jobs/2020/pannana_ml/app/pannana_ml_admin_frontend/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:/Users/lek-bit/Documents/jobs/2020/pannana_ml/app/pannana_ml_admin_frontend/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */

/* Original source: keras/callbacks.py */
import { BaseCallback } from './base_callbacks';
import { LayersModel } from './engine/training';
import { NotImplementedError } from './errors';
import { resolveScalarsInLogs } from './logs';
export var Callback = /*#__PURE__*/function (_BaseCallback) {
  _inherits(Callback, _BaseCallback);

  var _super = _createSuper(Callback);

  function Callback() {
    var _this;

    _classCallCheck(this, Callback);

    _this = _super.apply(this, arguments);
    /** Instance of `keras.models.Model`. Reference of the model being trained. */

    _this.model = null;
    return _this;
  }

  _createClass(Callback, [{
    key: "setModel",
    value: function setModel(model) {
      if (!(model instanceof LayersModel)) {
        throw new Error('model must be a LayersModel, not some other Container');
      }

      this.model = model;
    }
  }]);

  return Callback;
}(BaseCallback);

function less(currVal, prevVal) {
  return currVal < prevVal;
}

function greater(currVal, prevVal) {
  return currVal > prevVal;
}
/**
 * A Callback that stops training when a monitored quantity has stopped
 * improving.
 */


export var EarlyStopping = /*#__PURE__*/function (_Callback) {
  _inherits(EarlyStopping, _Callback);

  var _super2 = _createSuper(EarlyStopping);

  function EarlyStopping(args) {
    var _this2;

    _classCallCheck(this, EarlyStopping);

    _this2 = _super2.call(this);

    if (args == null) {
      args = {};
    }

    if (args.restoreBestWeights) {
      throw new NotImplementedError('restoreBestWeights = True is not implemented in EarlyStopping yet.');
    }

    _this2.monitor = args.monitor || 'val_loss';
    _this2.minDelta = Math.abs(args.minDelta || 0);
    _this2.patience = args.patience || 0;
    _this2.verbose = args.verbose || 0;
    _this2.mode = args.mode || 'auto';
    _this2.baseline = args.baseline;

    if (['auto', 'min', 'max'].indexOf(_this2.mode) === -1) {
      console.warn("EarlyStopping mode '".concat(_this2.mode, "' is invalid. ") + "Falling back to mode 'auto'.");
      _this2.mode = 'auto';
    }

    if (_this2.mode === 'min') {
      _this2.monitorFunc = less;
    } else if (_this2.mode === 'max') {
      _this2.monitorFunc = greater;
    } else {
      // For mode === 'auto'.
      if (_this2.monitor.indexOf('acc') !== -1) {
        _this2.monitorFunc = greater;
      } else {
        _this2.monitorFunc = less;
      }
    }

    if (_this2.monitorFunc === less) {
      _this2.minDelta *= -1;
    }

    return _this2;
  }

  _createClass(EarlyStopping, [{
    key: "onTrainBegin",
    value: function () {
      var _onTrainBegin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(logs) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.wait = 0;
                this.stoppedEpoch = 0;

                if (this.baseline != null) {
                  this.best = this.baseline;
                } else {
                  this.best = this.monitorFunc === less ? Infinity : -Infinity;
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onTrainBegin(_x) {
        return _onTrainBegin.apply(this, arguments);
      }

      return onTrainBegin;
    }()
  }, {
    key: "onEpochEnd",
    value: function () {
      var _onEpochEnd = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(epoch, logs) {
        var current;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return resolveScalarsInLogs(logs);

              case 2:
                current = this.getMonitorValue(logs);

                if (!(current == null)) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return");

              case 5:
                if (this.monitorFunc(current - this.minDelta, this.best)) {
                  this.best = current;
                  this.wait = 0; // TODO(cais): Logic for restoreBestWeights.
                } else {
                  this.wait++;

                  if (this.wait >= this.patience) {
                    this.stoppedEpoch = epoch;
                    this.model.stopTraining = true;
                  } // TODO(cais): Logic for restoreBestWeights.

                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onEpochEnd(_x2, _x3) {
        return _onEpochEnd.apply(this, arguments);
      }

      return onEpochEnd;
    }()
  }, {
    key: "onTrainEnd",
    value: function () {
      var _onTrainEnd = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(logs) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.stoppedEpoch > 0 && this.verbose) {
                  console.log("Epoch ".concat(this.stoppedEpoch, ": early stopping."));
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onTrainEnd(_x4) {
        return _onTrainEnd.apply(this, arguments);
      }

      return onTrainEnd;
    }()
  }, {
    key: "getMonitorValue",
    value: function getMonitorValue(logs) {
      if (logs == null) {
        logs = {};
      }

      var monitorValue = logs[this.monitor];

      if (monitorValue == null) {
        console.warn("Metric for EarlyStopping ".concat(this.monitor, " is not available. ") + "Available metrics are: ".concat(Object.keys(logs)));
      }

      return monitorValue;
    }
  }]);

  return EarlyStopping;
}(Callback);
/**
 * Factory function for a Callback that stops training when a monitored
 * quantity has stopped improving.
 *
 * Early stopping is a type of regularization, and protects model against
 * overfitting.
 *
 * The following example based on fake data illustrates how this callback
 * can be used during `tf.LayersModel.fit()`:
 *
 * ```js
 * const model = tf.sequential();
 * model.add(tf.layers.dense({
 *   units: 3,
 *   activation: 'softmax',
 *   kernelInitializer: 'ones',
 *   inputShape: [2]
 * }));
 * const xs = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 * const ys = tf.tensor2d([[1, 0, 0], [0, 1, 0]], [2, 3]);
 * const xsVal = tf.tensor2d([4, 3, 2, 1], [2, 2]);
 * const ysVal = tf.tensor2d([[0, 0, 1], [0, 1, 0]], [2, 3]);
 * model.compile(
 *     {loss: 'categoricalCrossentropy', optimizer: 'sgd', metrics: ['acc']});
 *
 * // Without the EarlyStopping callback, the val_acc value would be:
 * //   0.5, 0.5, 0.5, 0.5, ...
 * // With val_acc being monitored, training should stop after the 2nd epoch.
 * const history = await model.fit(xs, ys, {
 *   epochs: 10,
 *   validationData: [xsVal, ysVal],
 *   callbacks: tf.callbacks.earlyStopping({monitor: 'val_acc'})
 * });
 *
 * // Expect to see a length-2 array.
 * console.log(history.history.val_acc);
 * ```
 *
 * @doc {
 *   heading: 'Callbacks',
 *   namespace: 'callbacks'
 * }
 */

export function earlyStopping(args) {
  return new EarlyStopping(args);
}
export var callbacks = {
  earlyStopping: earlyStopping
};